// extracted by mini-css-extract-plugin
export default {"ButtonFunction":"ButtonFunction_ButtonFunction__LXC0F"};